import React from 'react';
import PropTypes from 'prop-types';

import { InputAdornment as MuiInputAdornment } from '@material-ui/core';

const InputAdornment = ({ children, ...rest }) => {
  return (
    <MuiInputAdornment
      {...rest}
    >
      { children }
    </MuiInputAdornment>
  )
}

InputAdornment.propTypes = {
  children: PropTypes.node.isRequired,
}

export default InputAdornment;



// WEBPACK FOOTER //
// ./src/components/base/InputAdornment/InputAdornment.js